// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Structure__Wrapper_1PQKx"};